.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
}

.link {
  display: flex;
  align-items: center;
  margin-right: 8px;
  font-weight: 300;
  text-decoration: none;
  cursor: pointer;
  color: inherit;
}

.homeLink {
  margin-right: 0;
  color: var(--tuna-palette-action-disabled);
}

.separator {
  color: var(--tuna-palette-text-secondary);
}

.nameLink {
  font-size: var(--tuna-typography-fontSize-md);
}
